<script>
import { mapGetters, mapState } from 'vuex'
import formatMixin from '../../mixins/formatMixin';
export default {
	mixins: [formatMixin],
	props : { },
	data() {
		return {
			loading: false,
			isLoading: false,
			root: ROOT_URL,
			app: APP_URL
		};
	},
	methods: {
		confirmaRecebimentoPremio: function(resgate) {
			var vm = this;
			vm.isLoading = true;
			//vm.$toasted.success('Aguarde, enviando...', {duration:3000, keepOnHover: true});
            this.$store.dispatch('campanhapontos/confirmarRecebimentoPremio', resgate)
                .then(response => {
					if(response == 'confirmacao-recebimento-premio-enviada')
					{
						vm.$store.dispatch('campanhapontos/getMeusResgates');
						vm.$toasted.success('Confirmação de recebimento enviada. Obrigado!', {duration:5000, keepOnHover: true});
					}
					else
					{
						vm.$toasted.error('Falha ao enviar a confirmação de recebimento. Por favor, tente novamente ou entre em contato com o seu Representante.', {duration:6000, keepOnHover: true, icon:'exclamation-circle'});
					}
                })
                .catch(error => {
					
					vm.$toasted.error('Falha ao enviar a confirmação de recebimento. Por favor, tente novamente ou entre em contato com o seu Representante..', {duration:6000, keepOnHover: true, icon:'exclamation-circle'});
				})
				.finally(() => {
					vm.isLoading = false;
				});
		}
	},
    computed: {
        ...mapState({
            saldoCampanhaPontos: state => state.campanhapontos.saldoCampanhaPontos,
            resgates: state => state.campanhapontos.resgates
		}),
        totalResgates: function() {
            var totalValue = 0;
			$.each(this.resgates, function(key, info) { totalValue += parseInt(info.pontuacao_total_ato); });
            return totalValue; 
        }
	}
}
</script>